var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    stroke: "#323232",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 7.55714,
    stroke: "#323232",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.07481,
    y1: 40.1438,
    x2: 24.1034,
    y2: 33.7438,
    stroke: "#323232",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.64279,
    y1: 10.4715,
    x2: 25.1856,
    y2: 26.0144,
    stroke: "#323232",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 37.9856,
    y1: 38.8143,
    x2: 53.5285,
    y2: 54.3572,
    stroke: "#323232",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30.4781,
    y1: 40.7462,
    x2: 24.789,
    y2: 61.9781,
    stroke: "#323232",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 41.4495,
    y1: 3.26056,
    x2: 35.7604,
    y2: 24.4925,
    stroke: "#323232",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40.5605,
    y1: 27.3437,
    x2: 61.5891,
    y2: 20.9437,
    stroke: "#323232",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.b9eaf82c7dedeebf3c2f980c0800ff38.svg";
export { ForwardRef as ReactComponent };